var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 20 } },
            [
              _c("informacoes-pessoa", {
                attrs: {
                  pessoa: _vm.dadosJson.interessado.pessoa,
                  dadosInteressadoRr: null,
                  razaoSocialName: "Razão Social:",
                  rendaFamiliar: null,
                  compararInformacoesPessoa: null,
                  isProcessoFisico: false
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "app-divider",
        { attrs: { label: "Endereço" } },
        [
          _c("informacoes-endereco", {
            staticClass: "margin-top",
            attrs: {
              slot: "body",
              endereco: _vm.dadosJson.interessado.pessoa.endereco
            },
            slot: "body"
          })
        ],
        1
      ),
      _vm.dadosJson.interessado.documentos
        ? _c("listagem-documentos", {
            attrs: {
              documentos: _vm.dadosJson.interessado.documentos,
              protocoloCadastroOriginal: _vm.dadosJson.protocolo,
              ownerDocumento: "INTERESSADO",
              compararDocumentos: null,
              versaoCadastro: null
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4788c88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4788c88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/OutorganteRf.vue
// module id = null
// module chunks = 